import Common from '@vendor/js/common';
import { nanoid } from 'nanoid';
import { i18n } from '@vendor/libs/lang/lang';
import { bootstrap } from '@vendor/js/theme/bootstrap';
import { $ } from '@vendor/libs/jquery/jquery';
import Sortable from 'sortablejs/modular/sortable.complete.esm.js';
const _OrderFormDictionaryCommonHandler = (function () {
    const body = $('body');
    const tableBody = $('[data-app-producers="table"] tbody, [data-app-products="table"] tbody');
    const sortTable = () => {
        const rows = tableBody
            .find('tr')
            .toArray()
            .sort((a, b) => {
            const t1 = $(a).find('input[name*="order"]').val();
            const t2 = $(b).find('input[name*="order"]').val();
            let s1 = parseInt(t1 ?? '99999999');
            let s2 = parseInt(t2 ?? '99999999');
            if (isNaN(s1)) {
                s1 = 99999999;
            }
            if (isNaN(s2)) {
                s2 = 99999999;
            }
            if (s1 == s2) {
                const name1 = $(a).find('input[name*="name"]').val();
                const name2 = $(b).find('input[name*="name"]').val();
                return window.naturalSort(name1, name2);
            }
            return s1 > s2 ? 1 : -1;
        });
        tableBody.empty();
        $.each(rows, (_index, row) => {
            tableBody.append(row);
        });
    };
    const markRowAsEdited = (row) => {
        row.find('td:last').html(`
      <span class="text-info" data-bs-toggle="tooltip" title="${i18n.trans('models/order_form_producers.pages.edit.row_edited')}">
        <i class="bx bx-info-circle"></i>
      </span>
    `);
        row.addClass('bg-info-light');
        row.removeClass('bg-success-light');
        $('[data-bs-toggle="tooltip"]').each(function () {
            new bootstrap.Tooltip(this);
        });
    };
    const addRow = () => {
        const id = nanoid();
        const orderInputs = tableBody
            .find('input[name*="order"]')
            .toArray()
            .reverse();
        let order = tableBody.find('tr').length + 1;
        for (const input of orderInputs) {
            const value = parseInt($(input).val());
            if (!isNaN(value)) {
                order = value + 1;
                break;
            }
        }
        const template = Common.compileTemplate('row', {
            id,
            order,
        });
        const row = $(template);
        tableBody.append(row);
        toggleOrderTooltips();
    };
    const updateOrderInputs = () => {
        tableBody.find('tr').each(function (index, row) {
            const orderInput = $(row).find('input[name*="order"]');
            const currentOrder = orderInput.val();
            const newOrder = index + 1;
            if (newOrder != currentOrder) {
                orderInput.val(index + 1).trigger('change');
            }
        });
    };
    const toggleOrderTooltips = () => {
        $('[data-app-handle]').each(function () {
            new bootstrap.Tooltip(this, { placement: 'left' });
        });
    };
    return {
        // Public functions
        init: function () {
            if (tableBody.find('tr').length === 0) {
                addRow();
            }
            const sortable = Sortable.create(tableBody[0], {
                handle: '[data-app-handle]',
                onChange: () => {
                    updateOrderInputs();
                    $('.tooltip').each(function () {
                        const tooltip = bootstrap.Tooltip.getInstance(this);
                        if (!tooltip) {
                            return;
                        }
                        tooltip.hide();
                    });
                },
            });
            sortTable();
            toggleOrderTooltips();
            $('[data-app-add_row="button"]').on('click', function () {
                addRow();
            });
            $('table tbody').on('change', 'input', function () {
                const row = $(this).closest('tr');
                markRowAsEdited(row);
            });
        },
    };
})();
window.OrderFormDictionaryCommonHandler = _OrderFormDictionaryCommonHandler;
